import { useQuery } from "@rocicorp/zero/react";
import { connectorKeyFile } from "../../../shared/credentials/connectorKeyFile";
import { queries } from "../../../shared/queries";
import { useConnectorSealingKey } from "../../hooks/useConnectorSealingKey";
import { downloadBlob } from "../../lib/downloadChat";
import { Button } from "../Button";
import { Text } from "../Text";
import { ConnectorEncryptionGuide } from "./ConnectorEncryptionGuide";
import { CopyableDetailField } from "./CopyableDetailField";
import { Card, DetailLabel, DetailList, SectionHeading } from "./shared";

export function ConnectorSealingKeyCard() {
  const key = useConnectorSealingKey();
  const [legacyKeys] = useQuery(queries.tenantSealingKeys());
  const legacy = legacyKeys?.find((k) => k.domain === "credentials");
  if (!key || !legacy || key.tenantId !== legacy.tenantId) return null;
  const postQuantum = key.algorithm === "mlkem1024";

  const downloadKey = () =>
    downloadBlob(
      new Blob(
        [
          JSON.stringify(
            connectorKeyFile(legacy, postQuantum ? key : undefined),
            null,
            2
          ),
        ],
        { type: "application/json" }
      ),
      `connector-encryption-key-${legacy.fingerprint}.json`
    );

  return (
    <Card>
      <SectionHeading
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          gap: 16,
        }}
      >
        <DetailLabel>
          <Text variant="text-regular-md">Connector encryption key</Text>
          <Text variant="text-small" color="var(--text-secondary)">
            Encrypt connector secrets for the API with this public key. The
            download includes the post-quantum key when available alongside the
            P-256 key.
          </Text>
        </DetailLabel>
        <Button
          variant="secondary"
          onClick={downloadKey}
          style={{ alignSelf: "flex-start", flexShrink: 0 }}
        >
          Download JSON
        </Button>
      </SectionHeading>
      <DetailList>
        <CopyableDetailField
          label={postQuantum ? "Post-quantum public key" : "Public key"}
          value={key.publicKey}
        />
        <CopyableDetailField
          label={postQuantum ? "Post-quantum fingerprint" : "Fingerprint"}
          value={key.fingerprint}
        />
        {postQuantum && (
          <>
            <CopyableDetailField
              label="P-256 public key"
              value={legacy.publicKey}
            />
            <CopyableDetailField
              label="P-256 fingerprint"
              value={legacy.fingerprint}
            />
          </>
        )}
      </DetailList>
      <ConnectorEncryptionGuide
        publicKey={key.publicKey}
        fingerprint={key.fingerprint}
      />
    </Card>
  );
}
